import { Radio } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { default as style } from "styled-components";
import delete1 from "../../assets/icons/Bin.svg";
import Package from "../../assets/icons/package.svg";
import moment from "moment";
import Calendericon from "../../assets/icons/Calendar with interaction.svg";
import Kebab from "../../assets/icons/Kebab Calculations.svg";
import EquipLine from "../../assets/icons/Line 216.svg";
import plusIcon from "../../assets/icons/Pluswhite.svg";
import SupplierIcon from "../../assets/icons/Suppliers.svg";
import downarrow from "../../assets/icons/downarrow.svg";
import Show from "../../assets/icons/eye.svg";
import xcircle from "../../assets/icons/x-circle.svg";
import "../../assets/styles/local/Equipment.css";
import AppDatePicker from "../../components/Common/AppDatePicker";
import EquipmentModal from "../../components/Dailogs/EquipmentModal";
import Header from "../../layouts/Header";
import {
  deleteEquipment,
  getEquipments,
  TurnUnavailable,
} from "../../redux/actions/action";
import { ROLES } from "../../utils/helpers/userRole";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const EquipmentList = () => {
  const history = useHistory();
  const [btnHover, setBtnHover] = useState(false);
  const roleAccess = window.localStorage.getItem("roleid");
  const [activePageOption, setActivePageOption] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [openMenu, setOpenMenu] = useState("");

  const dispatch = useDispatch();
  const equipments = useSelector((state) => state.user.equipments);
  const turnUnacailableRes = useSelector(
    (state) => state.user.turnUnacailableRes,
  );
  const companyId = window.localStorage.getItem("companyid");
  const [projectListTranslation, setProjectListTranslation] = useState({});
  const t = (key) => projectListTranslation?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("Equipment").then((res) => {
      setProjectListTranslation(res);
    });
  }, []);

  useEffect(() => {
    if (turnUnacailableRes.status === true) {
    } else {
      // setApimessage(fetchClient?.message);
    }
  }, [turnUnacailableRes]);

  const [refetch, setrefetch] = useState(true);
  const [querystring, setQuerystring] = useState("");

  useEffect(() => {
    if (querystring) {
      dispatch(
        getEquipments(companyId, itemsPerPage, pageNumber + 1, querystring),
      );
    } else {
      dispatch(
        getEquipments(companyId, itemsPerPage, pageNumber + 1, querystring),
      );
    }
  }, [
    companyId,
    itemsPerPage,
    refetch,
    pageNumber,
    turnUnacailableRes,
    querystring,
  ]);

  const PaginationChange = (event) => {
    setPageNumber(event.selected);
  };

  //setting default value of item per pages 50 & 20 to page 1
  useEffect(() => {
    if (itemsPerPage === 50 || itemsPerPage === 20) {
      setPageNumber(0);
    }
  }, [itemsPerPage]);

  useEffect(() => {
    if (equipments?.totalCount) {
      const totalCount = Number(equipments.totalCount);
      const calculatedTotalPages = Math.max(
        1,
        Math.ceil(totalCount / itemsPerPage),
      );
      setTotalPages(calculatedTotalPages);
    }
  }, [equipments, itemsPerPage]);

  return (
    <>
      <Header
        setQuery={setQuerystring}
        leftComponent={
          <div
            className="flex-wrap d-flex align-items-baseline"
            style={{ gap: "20px" }}
          >
            <div
              className="projectText2"
              onClick={() => {
                history.push("/equipment");
              }}
              style={{
                marginTop: "0px",
                fontSize: "16px",
                color: "#333333",
              }}
            >
              {/* Equipment */}
              {t("Equipment")}
            </div>
            <div className="head-white-bg">
              {/* List */}
              {t("List")}
            </div>
          </div>
        }
      />
      <div style={{ padding: "0 36.35px 0 24px" }}>
        {roleAccess !== ROLES.VIEWER && roleAccess !== ROLES.USER && (
          <div style={{ textAlign: "-webkit-right" }}>
            <button
              className="addQuoteBtn"
              onMouseEnter={() => setBtnHover(true)}
              onMouseLeave={() => setBtnHover(false)}
              style={{ gap: "10px" }}
              onClick={() => history.push("/equipment-details/")}
            >
              {btnHover && (
                <img
                  alt=""
                  src={plusIcon}
                  style={{
                    width: "clamp(18px, 1.318vw, 1.318vw)",
                    height: "clamp(18px, 1.318vw, 1.318vw)",
                  }}
                />
              )}
              {!btnHover && (
                <img
                  alt=""
                  src={SupplierIcon}
                  style={{
                    width: "clamp(18px, 1.318vw, 1.318vw)",
                    height: "clamp(18px, 1.318vw, 1.318vw)",
                    filter: "brightness(0) invert(1)",
                  }}
                />
              )}
              {/* Add Equipment */}
              {t("Add Equipment")}
            </button>
          </div>
        )}

        <div className="equip-scroll">
          <div className="equipmentListDiv">
            <div className="equip-list-grid">
              <p className="equip-list-head">
                {/* Item Description */}
                {t("Item Description")}
              </p>
              <p className="equip-list-head">
                {/* Plate No. */}
                {t("Plate No")}
              </p>
              <p className="equip-list-head">
                {/* Driver */}
                {t("Driver")}
              </p>
              <p className="equip-list-head">
                {/* Internal ID */}
                {t("Internal Id")}
              </p>
            </div>
            <img
              src={EquipLine}
              style={{ width: "100%", height: "auto", objectFit: "cover" }}
            />
            <div className="equip-items-list">
              {equipments?.data?.map((item) => {
                return (
                  <SingleItem
                    openMenu={openMenu}
                    setOpenMenu={setOpenMenu}
                    setrefetch={setrefetch}
                    item={item}
                    projectListTranslation={projectListTranslation}
                    roleAccess={roleAccess}
                  />
                );
              })}

              {/* Display a message when no data to display */}
              {equipments?.data?.length === 0 && (
                <div className="text-cente-r">No data to display!</div>
              )}
            </div>
          </div>
        </div>

        <div className="quotePageDiv">
          <section className="quotePageSec1" style={{ position: "relative" }}>
            {/* <p>Items per page</p> */}
            <p>{t("Items Per Page")}</p>
            <article
              className="quotePageArt"
              onClick={() => setActivePageOption(!activePageOption)}
              style={{ paddingLeft: "0", alignItems: "center" }}
            >
              <p>{itemsPerPage}</p>
              <img
                src={downarrow}
                alt=""
                style={{
                  width: "10px",
                  height: "6px",
                  transform: activePageOption
                    ? "rotate(-180deg)"
                    : "rotate(0deg)",
                  transitionDuration: "300ms",
                }}
              />
            </article>
            <article
              className="quotePageArt quotePageArt2"
              onClick={() => setActivePageOption(!activePageOption)}
              style={{
                position: "absolute",
                right: "0",
                bottom: "0",
                height: activePageOption
                  ? "clamp(82px, 6.003vw, 6.003vw)"
                  : "0",
                transitionDuration: "300ms",
                visibility: activePageOption ? "visible" : "none",
                paddingTop: activePageOption ? "11px" : "0",
              }}
            >
              <article
                style={{
                  display: activePageOption ? "flex" : "none",
                  flexDirection: "column",
                  gap: "10px",
                  alignItems: "start",
                }}
              >
                <p
                  style={{
                    fontWeight: itemsPerPage === 10 ? "800" : "700",
                    color: itemsPerPage === 10 ? "#95A7C6" : "#333333",
                  }}
                  onClick={() => setItemsPerPage(10)}
                >
                  10
                </p>
                <p
                  style={{
                    fontWeight: itemsPerPage === 20 ? "800" : "700",
                    color: itemsPerPage === 20 ? "#95A7C6" : "#333333",
                  }}
                  onClick={() => setItemsPerPage(20)}
                >
                  20
                </p>
              </article>
              <article
                className="quotePageArt"
                onClick={() => setActivePageOption(!activePageOption)}
                style={{
                  paddingLeft: "0",
                  alignItems: "center",
                  display: activePageOption ? "flex" : "none",
                }}
              >
                <p
                  style={{
                    fontWeight: itemsPerPage === 50 ? "800" : "700",
                    color: itemsPerPage === 50 ? "#95A7C6" : "#333333",
                  }}
                  onClick={() => setItemsPerPage(50)}
                >
                  50
                </p>
                <img
                  alt=""
                  src={downarrow}
                  style={{
                    width: "10px",
                    height: "6px",
                    transform: activePageOption
                      ? "rotate(-180deg)"
                      : "rotate(0deg)",
                    transitionDuration: "300ms",
                  }}
                />
              </article>
            </article>
          </section>
          <section className="quotePageSec2">
            <div className="table-filter-info-member">
              <ReactPaginate
                nextLabel=""
                forcePage={pageNumber}
                disableInitialCallback={true}
                onPageChange={PaginationChange}
                pageRangeDisplayed={3}
                marginPagesDisplayed={1}
                pageCount={totalPages}
                previousLabel=""
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="d-none"
                nextClassName="d-none"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="quote-pagination"
                activeClassName="active"
                renderOnZeroPageCount={null}
              />
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default EquipmentList;

const SingleItem = ({
  item = {},
  setrefetch = () => {},
  openMenu,
  setOpenMenu,
  projectListTranslation,
  roleAccess,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [menuActive, setMenuActive] = useState(false);
  const [DeleteModal, setDeleteModal] = useState(false);
  const [typeReason, setTypeReason] = useState("");
  const [validDate, setValidDate] = useState(false);
  const t = (key) => projectListTranslation?.[key] || "";
  const handleDelete = () => {
    deleteEquipment(item?.equipmentid).then((s) => {
      setrefetch((pre) => !pre);
    });
    setDeleteModal(false);
  };

  const BpIcon = style("span")(() => ({
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      "dark" === "dark"
        ? "0 0 0 1px rgb(16 22 26 / 40%)"
        : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "dark" === "dark" ? "#FFFFFF" : "#f5f8fa",
    backgroundImage:
      "dark" === "dark"
        ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
        : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "dark" === "dark" ? "#FFFFFF" : "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background:
        "dark" === "dark" ? "rgba(57,75,89,.5)" : "rgba(206,217,224,.5)",
    },
  }));

  const BpCheckedIcon = style(BpIcon)({
    backgroundColor: "#00246A",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 0,
      height: 16,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  });

  const [visible, setVisible] = useState({});
  const [type, setType] = useState("Definitive");
  const [temporaryFromDate, setTemporaryFromDate] = useState("");
  const [temporaryToDate, setTemporaryToDate] = useState("");
  const [confirmBtn, setConfirmBtn] = useState(false);
  const [isDefinitivelyUnavailable, setIsDefinitivelyUnavailable] =
    useState(true);
  const [isTemporaryUnavailable, setIsTemporaryUnavailable] = useState(false);

  const currentDate = new Date();
  const fromDate = new Date(temporaryFromDate);
  const toDate = new Date(temporaryToDate);

  const isDateInRange = (date, startDate, endDate) => {
    return date >= startDate && date <= endDate;
  };

  const ankitColor = isDateInRange(currentDate, fromDate, toDate) ? "red" : "";

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  const kebabRef = useRef();

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (kebabRef.current && !kebabRef.current.contains(event.target)) {
      setOpenMenu("");
      setVisible({});
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  // Check if the current date is within any unavailability range
  // const now = moment(); // current date and time
  // const isInUnavailableRange = item.unavailibility.some(({ from, to }) => {
  //   const fromDate = moment(from);
  //   const toDate = moment(to);
  //   return now.isBetween(fromDate, toDate, null, "[]"); // inclusive
  // });

  const now = moment().startOf("day"); // for full day includes
  const isInUnavailableRange = item.unavailibility.some(({ from, to }) => {
    const fromDate = moment(from).startOf("day");
    const toDate = moment(to).endOf("day"); // endOf to include full last day
    return now.isBetween(fromDate, toDate, null, "[]"); // inclusive
  });
  console.log("asc22 all EquipList", item);
  console.log("asc23 unavailable", isInUnavailableRange);

  return (
    <>
      <div className="equip-single-item">
        <div
          className="equip-list-grid equip-list"
          style={{ position: "relative", height: "auto" }}
        >
          <div className="equipList-desc">
            {/* <img src={item?.picture} alt={item?.platenumber} /> */}
            {item?.picture ? (
              <div
                className="equip-medium-input-box-image equip-picture-box"
                style={{ maxWidth: "90px" }}
              >
                <img
                  src={item?.picture}
                  alt={item?.platenumber}
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "contain",
                    borderRadius: "clamp(8px, 0.586vw, 0.586vw)",
                  }}
                />
              </div>
            ) : (
              <div
                className="equip-medium-input-box-image equip-picture-box"
                style={{ maxWidth: "90px" }}
              >
                <img
                  src={Package}
                  alt={item?.platenumber}
                  style={{ weight: "16px", height: "16px", objectFit: "cover" }}
                />
                <div className="product-image-title">{t("Picture")}</div>
              </div>
            )}

            <p
              className={
                item?.isDefinitivelyUnavailable === true ||
                (item?.isTemporaryUnavailable === true && isInUnavailableRange)
                  ? "grayRow"
                  : "equip-list-item-text"
              }
              onClick={() =>
                history.push("/equipment-details/" + item?.equipmentid)
              }
            >
              {item?.equipmentname || item?.itemdescription}
            </p>
          </div>
          <p
            className={
              item?.isDefinitivelyUnavailable === true ||
              (item?.isTemporaryUnavailable === true && isInUnavailableRange)
                ? "grayRow"
                : "equip-list-item-text"
            }
          >
            {item?.platenumber}
          </p>
          <div className="equipList-driver">
            {item?.drivername && (
              <img src={item?.driverimage || Package} alt="" />
            )}
            <p
              className={
                item?.isDefinitivelyUnavailable === true ||
                (item?.isTemporaryUnavailable === true && isInUnavailableRange)
                  ? "grayRow"
                  : "equip-list-item-text"
              }
              style={{ color: "#333333" }}
            >
              {item?.drivername || "No driver assigned"}
            </p>
          </div>
          <p
            className={
              item?.isDefinitivelyUnavailable === true ||
              (item?.isTemporaryUnavailable === true && isInUnavailableRange)
                ? "grayRow"
                : "equip-list-item-text"
            }
          >
            {item?.equipmentcode}
          </p>
          <img
            src={Kebab}
            alt="menu icon"
            className="quote-menu-icon"
            style={{
              transitionDuration: "300ms",
              transform: openMenu === item.equipmentid && "rotate(-90deg)",
            }}
            onClick={(e) => {
              e.stopPropagation(); //like => e.preventDefault.

              if (openMenu === item.equipmentid) {
                setOpenMenu("");
                setVisible({});
              } else {
                setOpenMenu(item.equipmentid);
              }
            }}
          />
          <section
            ref={kebabRef}
            onClick={(e) => {
              e.stopPropagation(); //like => e.preventDefault.
            }}
            className="quote-menu equip-list-menu"
            style={{
              transform:
                openMenu === item.equipmentid ? "scale(1)" : "scale(0)",
              transitionDuration: "300ms",
            }}
          >
            <div className="menu-icon-cont">
              <img
                src={Kebab}
                alt="menu icon"
                className="quote-menu-icon inside-menu"
                style={{
                  transform: "rotate(-90deg)",
                }}
                onClick={() => {
                  if (openMenu === item.equipmentid) {
                    setOpenMenu("");
                    setVisible({});
                  } else {
                    setOpenMenu(item.equipmentid);
                  }
                }}
              />
            </div>
            <div className="quote-menu-list fc">
              <section
                onClick={() => setVisible({ [item.equipmentid]: true })}
                // className="fr menu-single-item"
                className={
                  item?.isDefinitivelyUnavailable === true ||
                  (item?.isTemporaryUnavailable === true &&
                    isInUnavailableRange)
                    ? "hidden"
                    : "fr menu-single-item"
                }
                style={{
                  gap: "10px",
                  pointerEvents:
                    roleAccess !== ROLES.VIEWER && roleAccess !== ROLES.USER
                      ? "auto"
                      : "none",
                }}
              >
                <img src={Show} alt="Menu Icons" />
                {/* <p>Turn Unavailable</p> */}
                <p>{t("Turn Unavailable")}</p>
              </section>
              <section
                onClick={() => {
                  setMenuActive(false);
                  setDeleteModal(true);
                }}
                className="fr menu-single-item"
                style={{
                  gap: "10px",
                  pointerEvents:
                    roleAccess !== ROLES.VIEWER && roleAccess !== ROLES.USER
                      ? "auto"
                      : "none",
                }}
              >
                <img src={delete1} alt="Menu Icons" />
                {/* <p>Delete</p> */}
                <p>{t("Delete")}</p>
              </section>
            </div>
            {visible?.[item?.equipmentid] && (
              <section
                className=".quote-menu equip-list-menu-1"
                style={{
                  transform:
                    openMenu === item?.equipmentid ? "scale(1)" : "scale(0)",
                  transitionDuration: "300ms",
                }}
              >
                <div className="menu-icon-cont">
                  <img
                    src={xcircle}
                    onClick={() => setVisible({ [item.equipmentid]: false })}
                    alt="menu icon"
                    className="quote-menu-icon inside-menu-1"
                    style={{
                      transform: "rotate(-90deg)",
                    }}
                  />
                </div>

                <div className="quote-menu-list fc">
                  <section
                    className="fr menu-single-item"
                    style={{ gap: "10px", marginTop: "30px" }}
                  >
                    {/* <p>Turn Unavailable</p> */}
                    <p>{t("Turn Unavailable")}</p>
                  </section>
                  <div style={{ display: "flex", paddingLeft: "12px" }}>
                    <Radio
                      checked={type === "Definitive"}
                      onClick={() => {
                        setType("Definitive");
                        setIsDefinitivelyUnavailable(true);
                      }}
                      value="Definitive"
                      name="radio-buttons"
                      inputProps={{ "aria-label": "A" }}
                      checkedIcon={<BpCheckedIcon />}
                      icon={<BpIcon />}
                      size="small"
                      disableRipple={true}
                      disableFocusRipple={true}
                      sx={{
                        ":hover": {
                          backgroundColor: "transparent",
                        },
                      }}
                    />
                    <p
                      onClick={() => setType("Definitive")}
                      style={{
                        fontSize: "x-small",
                        marginTop: "10px",
                        cursor: "pointer",
                      }}
                    >
                      {/* Definitive */}
                      {t("Definitive")}
                    </p>
                  </div>
                  <textarea
                    name="description"
                    className={"text-description-pop-1 w-auto ps-2"}
                    style={{
                      marginLeft: "25px",
                      maxWidth: "clamp(155px, 8.204vw, 10.204vw)",
                    }}
                    // placeholder={"Type a reason"}
                    placeholder={t("Type a reason")}
                    value={typeReason}
                    onChange={(e) => {
                      setTypeReason(e.target.value);
                    }}
                  />
                  <div style={{ paddingLeft: "12px" }}>
                    <div style={{ display: "flex" }}>
                      <Radio
                        checked={type === "Temporary"}
                        value="Temporary"
                        name="radio-buttons"
                        inputProps={{ "aria-label": "A" }}
                        checkedIcon={<BpCheckedIcon />}
                        onClick={() => {
                          setType("Temporary");
                          setIsTemporaryUnavailable(true);
                          setIsDefinitivelyUnavailable(false);
                        }}
                        icon={<BpIcon />}
                        size="small"
                        disableRipple={true}
                        disableFocusRipple={true}
                        sx={{
                          ":hover": {
                            backgroundColor: "transparent",
                          },
                        }}
                      />
                      <p
                        onClick={() => setType("Temporary")}
                        style={{
                          fontSize: "x-small",
                          marginTop: "10px",
                          cursor: "pointer",
                        }}
                      >
                        {/* Temporary */}
                        {t("Temporary")}
                      </p>
                    </div>

                    <label
                      className={type === "Definitive" ? "pointerEvent" : ""}
                      style={{
                        display: "flex",
                        width: "94%",
                        marginLeft: "15px",
                      }}
                    >
                      <p style={{ fontSize: "12px", opacity: ".5" }}>
                        {/* From */}
                        {t("From")}
                      </p>
                      <img
                        className="ps-2"
                        style={{ height: "15px", marginTop: "3px" }}
                        src={Calendericon}
                        alt="calender"
                      />
                      <AppDatePicker
                        onSelect={(d, event) => {
                          event.preventDefault();
                        }}
                        inputClassNames={"ms-1 equipment-date"}
                        dateFormat="dd/MM/yyyy"
                        className="calender-icon-date ps-2"
                        selected={temporaryFromDate}
                        onChange={(val) => {
                          setTemporaryFromDate(val);
                        }}
                        isDisabledForPast={true}
                      />
                    </label>

                    <label
                      className={type === "Definitive" ? "pointerEvent" : ""}
                      style={{
                        display: "flex",
                        marginLeft: "14px",
                        width: "94%",
                      }}
                    >
                      <p style={{ fontSize: "12px", opacity: ".5" }}>
                        {/* To */}
                        {t("To")}
                      </p>
                      <img
                        className="ps-4"
                        style={{ height: "16px", marginTop: "3px" }}
                        src={Calendericon}
                        alt="calender"
                      />
                      <AppDatePicker
                        onSelect={(d, event) => {
                          event.preventDefault();
                        }}
                        inputClassNames={"ms-1 equipment-date"}
                        dateFormat="dd/MM/yyyy"
                        className="calender-icon-date ps-2"
                        selected={temporaryToDate}
                        onChange={(val) => {
                          setTemporaryToDate(val);
                        }}
                        isDisabledForPast={true}
                      />
                    </label>
                  </div>
                </div>
                <div
                  class="validDate-func"
                  style={{
                    fontSize: "12px",
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    color: "red",
                  }}
                >
                  {validDate ? "To date must be greater than from date." : ""}
                </div>

                <div className="confirmDiv pt-3">
                  <button
                    // disabled={typeReason === ""}
                    disabled={
                      type === "Definitive" ? !typeReason.trim() : false
                    } // Disable if typeReason contains only spaces
                    className="confirmBtn"
                    onClick={() => {
                      if (type === "Definitive") {
                        setConfirmBtn(true);
                        setVisible({ [item.equipmentid]: false });
                        setOpenMenu(false);
                        setValidDate(false);
                        setTimeout(() => {
                          dispatch(
                            TurnUnavailable(
                              item.equipmentid,
                              "0",
                              isDefinitivelyUnavailable,
                              isTemporaryUnavailable,
                              typeReason,
                              temporaryFromDate,
                              temporaryToDate,
                            ),
                          );
                        }, 2000);
                      } else {
                        if (
                          temporaryToDate &&
                          temporaryFromDate &&
                          temporaryToDate > temporaryFromDate
                        ) {
                          setConfirmBtn(true);
                          setVisible({ [item.equipmentid]: false });
                          setOpenMenu(false);
                          setValidDate(false);
                          setTimeout(() => {
                            dispatch(
                              TurnUnavailable(
                                item.equipmentid,
                                "0",
                                isDefinitivelyUnavailable,
                                isTemporaryUnavailable,
                                typeReason,
                                temporaryFromDate,
                                temporaryToDate,
                              ),
                            );
                          }, 2000);
                        } else {
                          // Temporary To date is not greater than Temporary From date
                          // You can handle this case, for example, by showing a message or preventing the action
                          console.log(
                            "Temporary To date must be greater than Temporary From date",
                          );
                          setValidDate(true);
                        }
                      }
                    }}
                  >
                    {/* Confirm */}
                    {t("Confirm")}
                  </button>
                </div>
              </section>
            )}
          </section>
        </div>
        <div className="equip-list-item-line"></div>
      </div>

      <EquipmentModal
        animation={true}
        handleDelete={handleDelete}
        show={DeleteModal}
        onHide={() => setDeleteModal(false)}
        title1={
          // "This data will be removed from the system"
          t("This data will be removed from the system")
        }
        title2={
          // "and cannot be undone."
          t("and cannot be undone.")
        }
        title3={
          "Do you want to proceed?"
          // projectListTranslation[69]?.translation
        }
        no={
          // "No"
          t("No")
        }
        yes={
          // "Yes"
          t("Yes")
        }
      />
    </>
  );
};
